import { FC } from "react";

const ProductSlider: FC = () => {
	return (
		<div className="title__container">
			<div className="title__wrapper">
				<img
					style={{ width: "100%" }}
					src="/img/widgets/product-slider.png"
					alt=""
				/>
			</div>
		</div>
	);
};

export const TwoProductsSlider: FC = () => {
	return (
		<div className="title__container">
			<div className="title__wrapper">
				<img
					style={{ width: "100%" }}
					src="/img/widgets/two-products.jpg"
					alt=""
				/>
			</div>
		</div>
	);
};

export default ProductSlider;
